import { render, staticRenderFns } from "./RelaySelectLocationSize.vue?vue&type=template&id=13bb6cbc&"
import script from "./RelaySelectLocationSize.vue?vue&type=script&lang=ts&"
export * from "./RelaySelectLocationSize.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports